import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { HomePage } from "@/pages/HomePage";
import { ArticlePage } from "@/pages/ArticlePage";
import { WriterProfilePage } from "@/pages/WriterProfilePage";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/writer/DashboardPage";
import { ArticlesPage } from "@/pages/writer/ArticlesPage";
import { NewArticlePage } from "@/pages/writer/NewArticlePage";
import { EditArticlePage } from "@/pages/writer/EditArticlePage";
import { OnboardPage } from "@/pages/writer/OnboardPage";
import { ProfilePage } from "@/pages/writer/ProfilePage";

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/writer/:id" element={<WriterProfilePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/writer/onboard"
              element={
                <ProtectedRoute>
                  <OnboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/writer/profile/edit"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/writer/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/writer/articles"
              element={
                <ProtectedRoute>
                  <ArticlesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/writer/articles/new"
              element={
                <ProtectedRoute>
                  <NewArticlePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/writer/articles/:id/edit"
              element={
                <ProtectedRoute>
                  <EditArticlePage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
        <Analytics />
      </div>
    </BrowserRouter>
  );
}
